import { createFileRoute } from '@tanstack/react-router';

import { NetworkHealthPage } from '@/pages/networkHealth/NetworkHealthPage.tsx';

export const Route = createFileRoute('/(app)/utils/networkHealth')({
  component: NetworkHealthPage,
});
